
define('ldsh!modules/editor/templates/controls/resize_right', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="handle cr" id="lpg-e"></div>\n';

}
return __p
};});

